"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

var _FooterTabbar = _interopRequireDefault(require("components/FooterTabbar"));

var _VanFieldSelectPicker = _interopRequireDefault(require("components/VanFieldSelectPicker"));

var _VanFieldSelectDate = _interopRequireDefault(require("components/VanFieldSelectDate"));

var _validator = _interopRequireDefault(require("@/plugins/validator"));

var _index = require("@/api/goods/index");

var _goods = require("@/api/goods");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      goods: {},
      data: {},
      errorMsg: {},
      rules: {}
    };
  },
  components: {
    FooterTabbar: _FooterTabbar.default,
    VanFieldSelectPicker: _VanFieldSelectPicker.default,
    VanFieldSelectDate: _VanFieldSelectDate.default
  },
  computed: {},
  methods: {
    onSearch: function onSearch() {},
    onCancel: function onCancel() {},
    onClickLeft: function onClickLeft() {
      // this.$toast('onClickLeft');
      this.$router.back(-1);
    },

    /**
       * 验证方法
       * @param callback
       * @param data
       */
    validate: function validate(callback, data) {
      var _this = this;

      console.log(data);
      var obj = this;
      this.validator.validate(function (errors, fields) {
        _this.resetField();

        if (errors) {
          var flag = false;
          fields.forEach(function (item) {
            if (!flag) {
              flag = item.message;
            }
          });

          if (flag) {
            _this.$toast(flag);
          }
        } else {
          var res = [];
          var tips = '';
          Object.keys(_this.data).forEach(function (key) {
            var index = key.substr(6);
            res.push({
              id: _this.goods.fieldmatch[index].field.id,
              name: _this.goods.fieldmatch[index].field.name,
              value: _this.data[key]
            });
            tips += _this.goods.fieldmatch[index].field.name + ':' + _this.data[key] + '\n';
          });
          obj.$dialog.confirm({
            title: '确认信息',
            message: tips
          }).then(function () {
            (0, _goods.AddProfile)(obj.goods.id, {
              'data': res
            }).then(function (res) {
              // 跳转到商品详情页面并且传值
              obj.$router.push({
                name: 'Prodetail',
                query: {
                  id: obj.goods.id,
                  profile_id: res.data.id
                }
              });
            });
          }).catch(function () {});
        }

        callback && callback(errors, fields);
      }, data);
    },
    submit: function submit() {
      this.validate(function (errors, fields) {// this.$dialog.alert(this.data);
      });
    },

    /**
       * 清除验证提示
       * @param attrs
       */
    resetField: function resetField(attrs) {
      var _this2 = this;

      attrs = !attrs ? Object.keys(this.errorMsg) : Array.isArray(attrs) ? attrs : [attrs];
      attrs.forEach(function (attr) {
        _this2.errorMsg[attr] = '';
      });
    },
    reset: function reset() {
      this.data = {
        saleman_name: '',
        saleman_company: ''
      };
      this.validator.setData(this.data);
      this.resetField();
    },
    initData: function () {
      var _initData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$toast.loading({
                  mask: false,
                  message: '加载中...'
                });
                _context.next = 3;
                return (0, _goods.getGoodsProfile)(this.id).then(function (res) {
                  if (res.data) {
                    _this3.profile = res.data.data;
                  }
                });

              case 3:
                _context.next = 5;
                return (0, _index.getGoodsDetail)(this.id).then(function (res) {
                  res.data.fieldmatch = res.data.fieldmatch.map(function (d, key) {
                    if (d.is_must == 1) {
                      console.log(d.field.name + '必填');
                      _this3.rules['field_' + key] = {
                        required: true,
                        message: '请输入' + d.field.name
                      };
                    }

                    if (d.field.type == 1 || d.field.type == 2) {
                      d.field.options = d.field.options.map(function (r) {
                        return r.value;
                      });
                    }

                    var profile_value = ''; // 投保单号

                    // 投保单号
                    if (_this3.profile && _this3.profile[key] && [1, 2, 3].includes(_this3.profile[key]['id'])) {
                      profile_value = _this3.profile[key]['value'];
                    }

                    _this3.data['field_' + key] = profile_value;
                    return d;
                  });
                  _this3.goods = res.data;

                  _this3.$toast.clear();
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initData() {
        return _initData.apply(this, arguments);
      }

      return initData;
    }()
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.id = Number(this.$route.params.id);
              _context2.next = 3;
              return this.initData();

            case 3:
              this.validator = (0, _validator.default)(this.rules, this.data);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }()
};
exports.default = _default;